import { getTrainingOverview } from './getTrainingOverview';
import { Assignment } from '../models/assignment';
import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';
import cacheService from '../../../services/cacheService';
import { getTrainingItem } from './getTrainingItem';
import { TrainingItem } from '../models/trainingItem';

export const selfAssignTraining = (trainingId: string, userId: string, orgId: string) => {
  return Promise.all([getTrainingItem(trainingId), getTrainingOverview(userId, false)]).then(
    ([training, trainingOverview]: [TrainingItem, Assignment[]]): Promise<{
      type: 'TaskList' | 'Workflow';
      instanceId: string;
    }> => {
      const trainingType = training.trainingType === 'Workflow' ? 'Workflow' : 'TaskList';
      const existingAssignedTraining = trainingOverview.find(
        training => 'originalTrainingId' in training && training.originalTrainingId === trainingId
      );

      if (existingAssignedTraining) {
        return Promise.resolve({ type: trainingType, instanceId: existingAssignedTraining.instanceId });
      }
      const newTraining =
        trainingType === 'TaskList'
          ? { id: { taskListId: { id: trainingId } } }
          : {
              id: { workflowId: trainingId },
              entityOptions: training.orderedTaskListsForWorkflow.reduce((acc, taskList) => {
                if (taskList.date !== undefined) {
                  acc[taskList.entityId] = {
                    ...taskList.date,
                    _entityOptionType: 'DueDate',
                  };
                }
                return acc;
              }, {}),
            };

      const id = uuid.generate();

      return submitCommand(
        id,
        {
          id: id,
          userId: userId,
          training: newTraining,
          orgId: orgId,
        },
        'SelfAssignTraining',
        'AssignSucceeded',
        'AssignFailed'
      ).then(res => {
        if (res.instances.length === 0) {
          return Promise.reject(new Error('No instances found'));
        }
        const instanceId = res.instances[0].instanceId;

        cacheService.removeAllInPath(`/v1/trainingOverview`);
        return { type: trainingType, instanceId };
      });
    }
  );
};
